export const LIST_VIEW_ROUTE_NAME = 'list'
export const VIDEO_PLAYER_ROUTE_NAME = 'videoplayer'
